// PMT estándar: pv = monto financiado, fv = balloon (residual).
// Retorna el pago mensual positivo. Relación: más fv → menor pmt.
export function calcPMT(rate, n, pv, fv = 0) {
    if (rate === 0) return (pv - fv) / n;
    const pow = Math.pow(1 + rate, n);
    return (rate * (pv - fv / pow)) / (1 - 1 / pow);
}

export function solveRate(pmt, n, pv, fv = 0) {
    // PMT crece con la tasa → bisección ascendente
    let lo = 1e-7;
    let hi = 0.5;
    for (let i = 0; i < 150; i++) {
        const mid = (lo + hi) / 2;
        const test = calcPMT(mid, n, pv, fv);
        if (test < pmt) lo = mid;
        else hi = mid;
        if (Math.abs(hi - lo) < 1e-11) break;
    }
    return (lo + hi) / 2;
}

export function parseMoney(value) {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    const clean = String(value).replace(/[^0-9.-]/g, '');
    const n = parseFloat(clean);
    return Number.isNaN(n) ? 0 : n;
}

export const RESIDUAL_LIMITS = {
    24: 50,
    36: 45,
    48: 35,
    60: 20,
};

export function maxResidualForPlazo(plazo) {
    return RESIDUAL_LIMITS[plazo] ?? 0;
}

export function getResidualSteps(step = 5, max = 60) {
    const steps = [];
    for (let r = step; r <= max; r += step) steps.push(r);
    return steps;
}
